module.exports = __webpack_public_path__ + "0e4681b5178cfea1cc77c9987d7fb2f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/authors/images/kite.png
// module id = 851
// module chunks = 3